import React, { useState } from 'react';
import { Alert, Button, Card, Spinner } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import { savingAuth } from 'Services/AuthService';
import { useUserStore } from 'Store/userStore';
import { upperCaseThis, capitalizeFstLetterOfThis } from 'Utils/Helpers';

const ForcingAuth = ({ data, closeModal }) => {
    const [spinIt, setSpinIt] = useState(false);
    const history = useHistory();
    const setUser = useUserStore((state) => state.setUser);

    const { user, token } = data;

    const submitForm = async () => {
        try {
            setSpinIt(true);
            const switchingUser = savingAuth(token);
            toast.success('Vous avez changé de compte avec succès');
            setUser(switchingUser);
            history.replace('/');
        } catch (err) {
            toast.error("Une erreur s'est produite !");
            setSpinIt(false);
        }
    };

    return (
        <>
            <Alert variant="warning">
                <div className="mb-3">
                    <b>Attention:</b> Êtes-vous certain ? En procédant ainsi, vous passerez à un autre compte sans
                    option de retour. Pour revenir à l&apos;ancien compte, il faudra vous déconnecter puis vous
                    reconnecter.
                </div>
                <Card className="user-card">
                    <Card.Header as="h5">User Information</Card.Header>
                    <Card.Body>
                        <Card.Title>
                            {capitalizeFstLetterOfThis(user.firstName)} {upperCaseThis(user.lastName)}
                        </Card.Title>
                        <Card.Text>
                            <strong>Email:</strong> {user.email}
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Alert>
            <div className="d-flex justify-content-center gap-1">
                <Button variant="info" onClick={() => submitForm()} disabled={!!spinIt}>
                    Login
                    {!!spinIt && (
                        <>
                            &nbsp; <Spinner animation="border" size="sm" />
                        </>
                    )}
                </Button>
                <Button variant="secondary" onClick={() => closeModal()} disabled={!!spinIt}>
                    Retourner
                </Button>
            </div>
        </>
    );
};

export default ForcingAuth;
